"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigState = /** @class */ (function () {
    function ConfigState() {
        this.debug = false;
        this.maxHistoryLength = 10;
        Object.seal(this);
    }
    return ConfigState;
}());
exports.default = ConfigState;
//# sourceMappingURL=ConfigState.js.map